import React from "react";
import styled from "styled-components";

const Highlight = styled.span`
  background: #EBF1FD;
  border-radius: 40px;
  padding: 0px 16px;
  font-size: inherit; /* So it matches any parent font size */
`;

const Bold = styled.span`
  font-weight: 600;
  color: #2D70E2;
  font-size: inherit; /* Matches any parent font size */
`;

export default function QuestionInformation({ question, currentAnswer, onAnswerChange }) {
  // Grab the blocks array (heading, paragraph, text, checkbox)
  const { blocks = [] } = question.properties || {};

  /**
   * parseBracketsToReact:
   *  - Replaces [b]...[/b] with <Bold>...</Bold>
   *  - Replaces [hl]...[/hl] with <Highlight>...</Highlight>
   *  - Returns an array of strings/React elements.
   */
  function parseBracketsToReact(str) {
    if (!str) return null;

    // Regex that matches either [b]...[/b] or [hl]...[/hl]
    const pattern = /\[b\](.*?)\[\/b\]|\[hl\](.*?)\[\/hl\]/g;
    const elements = [];
    let lastIndex = 0;
    let match;

    // Loop through all bracketed matches
    while ((match = pattern.exec(str)) !== null) {
      // text before the bracketed tag
      if (match.index > lastIndex) {
        elements.push(str.slice(lastIndex, match.index));
      }

      // match[0] is the entire matched string, e.g. "[b]hello[/b]" or "[hl]highlight[/hl]"
      if (match[0].startsWith("[b]")) {
        const boldText = match[1]; // capture group for the text inside [b]...[/b]
        elements.push(<Bold key={`${match.index}-b`}>{boldText}</Bold>);
      } else {
        const highlightText = match[2]; // capture group for the text inside [hl]...[/hl]
        elements.push(<Highlight key={`${match.index}-hl`}>{highlightText}</Highlight>);
      }

      lastIndex = pattern.lastIndex;
    }

    // Remainder text after last match
    if (lastIndex < str.length) {
      elements.push(str.slice(lastIndex));
    }

    return elements;
  }

  return (
    <div style={{ marginTop: "1rem" }}>
      {blocks.map((block, idx) => {
        if (block.type === "heading") {
          return (
            <h2 key={idx}>
              {parseBracketsToReact(block.content)}
            </h2>
          );
        } else if (block.type === "paragraph" || block.type === "text") {
          return (
            <p key={idx}>
              {parseBracketsToReact(block.content)}
            </p>
          );
        } else if (block.type === "checkbox") {
          // e.g. a consent checkbox
          const isChecked = currentAnswer && currentAnswer[block.label] === true;
          return (
            <label key={idx} style={{ display: "block", marginTop: "0.5rem" }}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => {
                  onAnswerChange(question.uniqueId, {
                    ...(currentAnswer || {}),
                    [block.label]: e.target.checked,
                  });
                }}
              />{" "}
              {block.label}
            </label>
          );
        }
        return null;
      })}
    </div>
  );
}
